/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {InputAccessor} from '../input-accessor';
import {UiSelect} from "../ui-select/ui-select";

@Component({
    selector: 'ui-log-box',
    template: require('./ui-log-box.html'),
    styles: [require('./ui-log-box.less')],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: UiLogBox, multi: true}
    ]
})
export class UiLogBox extends InputAccessor {

    @Input() text: string;

    constructor(public elementRef: ElementRef) {
        super();
    }

    public prepareValueHook() {}


}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-log-box/ui-log-box.ts